import { Pipe, PipeTransform } from '@angular/core';
import { Tools } from '../helpers/tools';

class FidelityDateHelper {
  static transform(date: string): Date {
    //Conversion de la date d'expiration en Date javascript
    let parts = date.split('/');

    return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
  }
}

export class FidelityCardPointInfo {
  fidelityCard: FidelityCard;
  pointInfo: PointInfo;
}

export class FidelityCardPointSimulationDto {
  type: FidelityCardTypeEnum;
  cardFinalExpirationDate?: string;
  hasCard: boolean;
  cardNumber: string;
  freeCardEarnedPoints: number;
  premiumCardEarnedPoints: number;
  freeCardCoupons: LoyaltyCouponSimulationDto[];
  premiumCardCoupons: LoyaltyCouponSimulationDto[];
  amount?: number;

  constructor(source: Partial<FidelityCardPointSimulationDto>) {
    Object.assign(this, source);
    this.freeCardCoupons = this.freeCardCoupons.toSorted((a, b) => b.value.localeCompare(a.value));
    this.premiumCardCoupons = this.premiumCardCoupons.toSorted((a, b) => b.value.localeCompare(a.value));
  }

  get freeCardRewards(): string {
    return this.formatCouponString(this.freeCardCoupons);
  }

  get premiumCardRewards(): string {
    return this.formatCouponString(this.premiumCardCoupons);
  }

  private formatCouponString(coupons: LoyaltyCouponSimulationDto[]): string {
    return Tools.replaceLast(
      coupons.map(c => `${c.count} coupon${c.count > 1 ? 's' : ''} de ${c.value}`).join(', '),
      ',',
      ' et'
    );
  }
}

export class LoyaltyCouponSimulationDto {
  count: number;
  value: string;
}

export class FidelityCard {
  cardNumber: string;
  cardEnabled: boolean;
  creationDate: string;
  finalExpirationDate: string;
  type: FidelityCardTypeEnum;
  customerId: string;
  memberId: string;
  captainWalletUserId: string;
  cardIsPaidButNotActiveYet: boolean;

  get formatedCreationDate() {
    return FidelityDateHelper.transform(this.creationDate);
  }

  get formatedFinalExpirationDate() {
    return FidelityDateHelper.transform(this.finalExpirationDate);
  }
}

export enum FidelityCardTypeEnum {
  AUCUNE0 = 0,
  AUCUNE = 1,
  GRATUITE = 2,
  PREMIUM = 3,
  PREMIUMWAITING = 9,
}

@Pipe({
  name: 'fidelityCardTypeName',
})
export class FidelityCardTypePipe implements PipeTransform {
  transform(value: FidelityCardTypeEnum): string {
    const fidelityCardType = {
      [FidelityCardTypeEnum.AUCUNE]: 'fidelity-info.card-type-name.none',
      [FidelityCardTypeEnum.GRATUITE]: 'fidelity-info.card-type-name.free',
      [FidelityCardTypeEnum.PREMIUM]: 'fidelity-info.card-type-name.premium',
      [FidelityCardTypeEnum.PREMIUMWAITING]: 'fidelity-info.card-type-name.premium-waiting',
    };

    return fidelityCardType[value] || 'Inconnu'; // Retourne un texte par défaut si la clé n'est pas trouvée
  }
}

export class PointInfo {
  cardNumber: string;
  numberOfPoint: number;
  maxPointForNextStep: number;
  customerId: string;
  memberId: string;
  discountsList: AllGiftCardOfferCoupon;
}

export class AllGiftCardOfferCoupon {
  giftCardsList: GiftCard[];
  offerCouponsList: OfferCoupon[];
}

export class GiftCard {
  cardNumber: string;
  active: boolean;
  clipped: boolean;
  balance: number;
  usabilityStartDate: string;
  usabilityEndDate: string;
  title: string;
  label: string;
  heading: string;
  imageUrl: string;
  thumbImageUrl: string;
  originalImageUrl: string;

  get formatedUsabilityStartDate() {
    return FidelityDateHelper.transform(this.usabilityStartDate);
  }

  get formatedUsabilityEndDate() {
    return FidelityDateHelper.transform(this.usabilityEndDate);
  }
}

export class OfferCoupon {
  responseId: number;
  offerId: number;
  usable: boolean;
  cancelled?: boolean;
  usabilityStartDate: string;
  usabilityEndDate: string;
  name: string;
  type: string;
  urlToCoupon: string;
  code: string;
  usedDate?: Date;

  get formatedUsabilityStartDate() {
    return FidelityDateHelper.transform(this.usabilityStartDate);
  }

  get formatedUsabilityEndDate() {
    return FidelityDateHelper.transform(this.usabilityEndDate);
  }
}

export class GetCustomerFidelityInfoInput {
  idKingfisher: string;
}

export class GetCustomerFidelityInfoNouveauPointInput {
  customerId: string;
  amount: number;
}

export enum OfferValueType {
  PERCENTAGE = '%',
  AMOUNT = '€',
}

export enum HabitationTypeCh {
  NonRenseigne = -1,
  Appartement = 0,
  Maison = 1,
}

export enum IsNewTenantCh {
  Yes = 0,
  No = 1,
  Eligible = 2,
}

export enum CustomerPropertySituationCh {
  NonRenseigne = -1,
  Proprietaire = 0,
  Locataire = 1,
}

export class MarketingConsentCustomerKfDto {
  optinEmail: boolean | null = false;
  optinSms: boolean | null = false;
  optinPhone: boolean | null = false;
  optoutPostal: boolean | null = true;

  constructor(init?: Partial<MarketingConsentCustomerKfDto>) {
    Object.assign(this, init);
  }
}

export class ProjectNext6MonthsListChDto {
  kitchen: boolean | null = false;
  bathroom: boolean | null = false;
  floorAndWall: boolean | null = false;
  insulation: boolean | null = false;
  storage: boolean | null = false;
  outdoor: boolean | null = false;

  constructor(init?: Partial<ProjectNext6MonthsListChDto>) {
    Object.assign(this, init);
  }
}

export enum MemberTypeCh {
  NonRenseigne = -1,
  Particulier = 0,
  Professionnel = 1,
}
